"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdProjectCategoryLabel = exports.SelectedRdProjectCategory = void 0;
var SelectedRdProjectCategory;
(function (SelectedRdProjectCategory) {
    SelectedRdProjectCategory["RD_CREDIT"] = "RD_CREDIT";
    SelectedRdProjectCategory["SECTION_174_ONLY"] = "SECTION_174_ONLY";
    SelectedRdProjectCategory["EXCLUDED"] = "EXCLUDED";
})(SelectedRdProjectCategory || (exports.SelectedRdProjectCategory = SelectedRdProjectCategory = {}));
exports.rdProjectCategoryLabel = {
    [SelectedRdProjectCategory.RD_CREDIT]: 'R&D Credit',
    [SelectedRdProjectCategory.SECTION_174_ONLY]: '§174 Only',
    [SelectedRdProjectCategory.EXCLUDED]: 'Excluded',
};
